import * as React from 'react'

import RedirectPage from './../component/redirectPage';

const DiagnosticCreatePage = () => {
  return <RedirectPage pageRedirectPath="/diagnostics/prerun-test-irtech" />;
};

export default DiagnosticCreatePage;